import { FormState } from "../types";

export default function QuickInfoPanel({ form }: { form: FormState }) {
    const checks: { label: string; pass: boolean }[] = [
        { label: "Title provided", pass: !!form.title.trim() },
        { label: "Description ≥ 60 chars", pass: form.description.length >= 60 },
        { label: "Image uploaded", pass: !!form.imagePreview },
        { label: "Issuing body set", pass: !!form.issuedBy.trim() },
        { label: "Issue date set", pass: !!form.issuedDate },
    ];
    const score = checks.filter((c) => c.pass).length;

    return (
        <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: 14, overflow: "hidden" }}>
            <div style={{
                display: "flex", alignItems: "center", gap: 10, padding: "14px 20px",
                borderBottom: "1px solid var(--border)", background: "var(--section-header)",
            }}>
                <span style={{ fontSize: 14, fontWeight: 600, color: "var(--text)", flex: 1 }}>Completeness</span>
                <span style={{ fontSize: 12, fontWeight: 600, color: score === checks.length ? "#6ddc6d" : score >= 3 ? "#f5a623" : "var(--text3)" }}>
                    {score}/{checks.length}
                </span>
            </div>
            <div style={{ padding: 16, display: "flex", flexDirection: "column", gap: 8 }}>
                {checks.map((c) => (
                    <div key={c.label} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <div style={{
                            width: 16, height: 16, borderRadius: "50%", flexShrink: 0,
                            background: c.pass ? "rgba(109,220,109,0.12)" : "rgba(255,255,255,0.05)",
                            border: `1px solid ${c.pass ? "rgba(109,220,109,0.3)" : "var(--border)"}`,
                            display: "flex", alignItems: "center", justifyContent: "center",
                            fontSize: 10, color: c.pass ? "#6ddc6d" : "var(--text3)",
                            transition: "all 0.2s",
                        }}>
                            {c.pass ? "✓" : "·"}
                        </div>
                        <span style={{ fontSize: 12, color: c.pass ? "var(--text2)" : "var(--text3)", transition: "color 0.2s" }}>
                            {c.label}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
}
